import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import Landing from "@/pages/Landing";
import SmoothScroll from "@/components/landing/premium/SmoothScroll";
import ScrollProgress from "@/components/landing/premium/ScrollProgress";

// Perf : react-router (~25 KB gz) n'est chargé que pour les pages secondaires.
// La page d'accueil (99 % du trafic PSI) est rendue sans routeur.
const RoutedApp = lazy(() => import("@/RoutedApp"));
const IS_LANDING = window.location.pathname === "/";

const RouteFallback = () => (
  <div className="fixed inset-0 bg-[#050505] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-white/20 border-t-white/80 rounded-full animate-spin" aria-label="Chargement" />
  </div>
);

// Retire le hero statique pré-rendu (index.html) dès que le vrai hero est peint sur "/", immédiatement ailleurs
const StaticHeroDismiss = () => {
  useEffect(() => {
    const el = document.getElementById("df-static");
    if (!el) return;
    const t = setTimeout(() => {
      el.style.opacity = "0";
      setTimeout(() => el.remove(), 400);
    }, IS_LANDING ? 250 : 0);
    return () => clearTimeout(t);
  }, []);
  return null;
};

function App() {
  return (
    <SmoothScroll>
      <StaticHeroDismiss />
      <ScrollProgress />
      {IS_LANDING ? (
        <Landing />
      ) : (
        <Suspense fallback={<RouteFallback />}>
          <RoutedApp />
        </Suspense>
      )}
    </SmoothScroll>
  );
}

export default App;
